import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ORingCordRoutingModule } from './o-ring-cord-routing.module';
import { ORingCordComponent } from './o-ring-cord.component';
import { PageHeaderModule } from '../page-header/page-header.module';
import { CtaFullWidthModule } from 'src/app/shared/cta-full-width/cta-full-width.module';
import { RelatedLinksModule } from '../related-links/related-links.module';

@NgModule({
  declarations: [ORingCordComponent],
  imports: [
    CommonModule,
    ORingCordRoutingModule,
    PageHeaderModule,
    CtaFullWidthModule,
    RelatedLinksModule
  ]
})
export class ORingCordModule { }
